import { render, staticRenderFns } from "./PackageServiceLogs.vue?vue&type=template&id=2ba285bf&scoped=true&"
import script from "./PackageServiceLogs.vue?vue&type=script&lang=js&"
export * from "./PackageServiceLogs.vue?vue&type=script&lang=js&"
import style0 from "./PackageServiceLogs.vue?vue&type=style&index=0&id=2ba285bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba285bf",
  null
  
)

export default component.exports